export const environment = {
  production: false,
  showPin: true,
  orgId: '684f0b7709cd3a0297654331',
  publicOrg: '684f0b7709cd3a0297654331',
  serverUrl: 'https://qa.api.wrna.interactivelife.me/wrna/',
  identityName: 'WRNA',
  customKeys: {
    roleAdmin: '5eb137f1d3123a407c7c97cc',
    roleCaseManager: '64dc639a4096f85368c00770',
    roleSupervisor: '64dc63c44096f85368c00772',
    roleClient: '64dc69d44096f85368c00776',
    roleResearcher: '688898f3bb6928780d72778d',
  },
  lockSite: false,
  rollbar: {
    apiKey: 'd21a6d0510cd40c3b15bb29bfb24e043',
  },
  environment: 'qa',
  casUrl: 'https://qa.api.wrna.interactivelife.me/wrna/',
  productId: 'fec86ca1-d772-4745-a0ef-1cb8ce2c0400',
  group: 'web-2.0',
  formLibrariesURL: 'https://qa.api.formlib.interactivelife.me/api/',
  serverTileUrl: 'https://qa.api.formlib.interactivelife.me/api/',
  projectName: 'wrna',
  orgType: 'wrna',
  s3: 'https://stellar-images-bucket-qa.s3.amazonaws.com/',
  appId: '684f0cf909cd3a0297654334',
  locationId: '684f0d6909cd3a0297654337',
  aliveAppIntervalMinutes: 30, // if you keep app inactive
  aliveCheckAppIntervalMinutes: 60, // if you keep app inactive pop a message
  firebaseVapidKey: 'BCLDDmne7U-VybZ3r3czg3Pzr7LcEJsfuxGp3_J77RGcVHI1i6w7QGD4G05vnvZuqmPucl2yiZqZKslIsUr2wsw',
  firebaseConfig: {
    apiKey: "AIzaSyAiQcz5XVk6aitQza-EZqqqPUpIDJ5efMA",
    authDomain: "wrna-2072b.firebaseapp.com",
    projectId: "wrna-2072b",
    storageBucket: "wrna-2072b.appspot.com",
    messagingSenderId: "107184913401",
    appId: "1:107184913401:web:a02a5b0ba76dd595665b28",
    measurementId: "G-YL8NV3LD0Z"
  },
  permissions: {
    roles: {
      "5eb137f1d3123a407c7c97cc": {// admin
        pages: {
          "rules": ["show", "create", "read", "update", "delete"],
          "tiles": ["show", "create", "read", "update", "delete"],
          "procedures": ["show", "create", "read", "update", "delete"],
          "score-reports": ["show", "create", "read", "update", "delete", "mappedScore"],
          "evaluation": ["show", "create", "read", "update", "delete"],
          "case-plan-templates": ["show", "create", "read", "update", "delete"],
        }
      },
      "64dc639a4096f85368c00770": {// CaseManager
        pages: {
          "rules": ["show", "read"],
          "tiles": [],
          "procedures": [],
          "score-reports": [],
          "evaluation": [],
          "case-plan-templates": ["show", "create", "read", "update", "delete"],
        },
      },
      "64dc63c44096f85368c00772": {// Supervisor
        pages: {
          "rules": ["show", "read"],
          "tiles": [],
          "procedures": [],
          "score-reports": [],
          "evaluation": [],
          "case-plan-templates": ["show", "create", "read", "update", "delete"],
        },
      },
      "64dc69d44096f85368c00776": {// client
        pages: {
          "rules": [],
          "tiles": [],
          "procedures": [],
          "score-reports": [],
          "evaluation": [],
          "case-plan-templates": [],
        },
      }
    }
  }
};
